// eslint-disable-next-line no-unused-vars, unused-imports/no-unused-imports
import "parsleyjs"
import "../styles/main.css"

import removeRegistrationErrors from "./registration"

import initializePasswordVisibilityToggles from "../accounts/togglePasswordVisibility"
document.addEventListener("DOMContentLoaded", initializePasswordVisibilityToggles)
document.addEventListener("DOMContentLoaded", removeRegistrationErrors)
